import React from 'react';
import { get, groupBy, map, size } from 'lodash/fp';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { OrderType } from '../../../../interfaces/pos';

const styles = StyleSheet.create({
  order: {
    borderRadius: 5,
    border: '1px solid #ddd',
    width: '100%',
    margin: '0 0 10px 0'
  },
  programName: {
    padding: 6,
    fontSize: 9,
    color: '#000',
    textAlign: 'center',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    textTransform: 'uppercase',
    backgroundColor: '#86cce7',
    fontWeight: 'bold'
  },
  locationSection: {
    width: '100%',
    borderBottom: 'none'
  },
  locationName: {
    padding: 6,
    fontSize: 10,
    color: '#000',
    textAlign: 'center',
    backgroundColor: '#efefef'
  },
  itemsSection: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  orderItem: {
    fontSize: 8,
    width: '25%',
    flexGrow: 0,
    textTransform: 'uppercase',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
  },
  itemName: {
    padding: 5,
    width: '75%',
    color: '#000',
    display: 'inline',
    flexGrow: 4
  },
  itemZone: {
    display: 'inline',
    fontSize: 8
  },
  itemQty: {
    width: '25%',
    padding: '5px 0',
    display: 'inline',
    textAlign: 'center',
    flexGrow: 1,
    fontSize: 11
  }
});

const VisitOrder = ({ data }) => {
  const { items, trackingMethod } = data;
  const itemsByLocation = groupBy('inventoryLocationId', items);
  return (
    <View style={styles.order}>
      <Text style={styles.programName}>{trackingMethod.name}</Text>
      <View style={styles.itemsSection}>
        {map(locationItems => {
          const itemsLength = size(locationItems);
          const withBorderLength = Math.floor(itemsLength / 4) * 4;
          const location = get('0.meta.location.name', locationItems);

          return (
            <View key={`location-${location}`} style={styles.locationSection}>
              <Text style={styles.locationName}>{location}</Text>
              <View style={styles.itemsSection}>
                {locationItems.map(({ id, quantity, meta }, i) => (
                  <View
                    key={`item-${id}`}
                    style={{
                      ...styles.orderItem,
                      borderBottom:
                        itemsLength >= 4 && i < withBorderLength
                          ? '1px solid #ddd'
                          : 'none',
                      borderRight: (i + 1) % 4 === 0 ? 'none' : '1px solid #ddd'
                    }}
                  >
                    <Text style={styles.itemName} break>
                      {get('item.name', meta)}
                    </Text>

                    <Text style={styles.itemQty}>{quantity}</Text>
                  </View>
                ))}
              </View>
            </View>
          );
        }, itemsByLocation)}
      </View>
    </View>
  );
};

VisitOrder.propTypes = {
  data: OrderType.isRequired
};

export default VisitOrder;
